import { FormControl, Validators, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';
import { Directive } from '@angular/core';

export class CustomEmail extends Validators {
    static validate(control: FormControl) {
        if (control.value) {
            const matches = control.value.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
            return matches ? null : { 'invalidEmail': true };
        } else {
            return null;
        }
    }
}

@Directive({
    selector: '[customEmail]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }]
  })
  export class EmailValidatorDirective implements Validator {
    validate(control: FormControl): ValidationErrors {
        return CustomEmail.validate(control);
    }
  }
